module.exports = __webpack_public_path__ + "res/img/connected.f6fe8c82.png";